/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CHANGE_PASSWORD,
  GET_USERS_LIST,
  GET_USER_DETAILS,
  LOGIN,
  LOGOUT,
  UPDATE_USER_DETAILS,
  UPDATE_USER_EMAIL_DETAILS,
  VERIFY_USER_EMAIL_DETAILS,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  FETCH_RANDOM_USERNAME_PWD,
  GET_QUALIFICATION,
} from '../constants/action-types'
import { UserData } from '../Actions'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { ActionTypes } from '../action'
import { getToken } from '../../util/utils'

const initialState = {
  isLoading: false,
  isLoggedin: JSON.parse(getToken('isLoggedIn') || 'false'),
  authToken: '',
  isLoggedout: false,
  user: {},
  userList: [],
  userDetails: {},
  onSaveLoading: false,
  errorMessage: '',
  isReceived: false,
  userDetailsData: {},
  randomUsernamePassword: {},
  qualifications: [],
}

const reducer = persistReducer(
  {
    storage,
    key: 'basecode-demo',
    whitelist: ['authToken', 'user', 'userDetailsData'],
  },
  (state: UserData = initialState, action: ActionTypes) => {
    switch (action.type) {
      case LOGIN.LOGIN_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          isLoading: true,
          progress: true,
          errorMessage: '',
          isLoggedout: false,
        }
      case LOGIN.LOGIN_SUCCESS:
        const user: any = action.payload
        return {
          ...state,
          user: user,
          ...action.payload,
          errorMessage: '',
          isLoggedin: true,
          authToken: user.response.data.access,
          userDetails: user.response.data.user,
          isLoading: false,
          isLoggedout: false,
          progress: true,
        }

      case LOGIN.LOGIN_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoggedin: false,
          isLoading: false,
          progress: false,
        }
      case LOGOUT.LOGOUT_INITIALIZATION:
        return {
          ...state,
          ...action.payload,
          isLoading: true,
        }
      case LOGOUT.LOGOUT_SUCCESS:
        localStorage.removeItem('login-auth-token')
        return {
          ...state,
          ...action.payload,
          isLoggedout: true,
          isLoggedin: false,
          isLoading: false,
        }
      case LOGOUT.LOGOUT_ERORR:
        return {
          ...state,
          ...action.payload,
          isLoggedout: false,
          isLoading: false,
        }

      case CHANGE_PASSWORD.CHANGE_PASSWORD_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          onSaveLoading: true,
        }
      case CHANGE_PASSWORD.CHANGE_PASSWORD_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          onSaveLoading: false,
        }
      case CHANGE_PASSWORD.CHANGE_PASSWORD_ERORR:
        return {
          ...state,
          errorMessage: action.payload,
          onSaveLoading: false,
        }
      case GET_USER_DETAILS.GET_USER_DETAILS_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          isLoading: true,
          progress: true,
          errorMessage: '',
          isLoggedout: false,
        }
      case GET_USER_DETAILS.GET_USER_DETAILS_SUCCESS:
        const userDetails: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          progress: true,
          userDetailsData: userDetails,
        }

      case GET_USER_DETAILS.GET_USER_DETAILS_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
          progress: false,
        }
      case UPDATE_USER_EMAIL_DETAILS.UPDATE_USER_EMAIL_DETAILS_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          onSaveLoading: true,
        }
      case UPDATE_USER_EMAIL_DETAILS.UPDATE_USER_EMAIL_DETAILS_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          isReceived: true,
          onSaveLoading: false,
        }
      case UPDATE_USER_EMAIL_DETAILS.UPDATE_USER_EMAIL_DETAILS_ERORR:
        return {
          ...state,
          errorMessage: action.payload,
          isReceived: false,
          onSaveLoading: false,
        }
      case VERIFY_USER_EMAIL_DETAILS.VERIFY_USER_EMAIL_DETAILS_INITIALIZATION:
        return {
          ...state,
          errorMessage: '',
          onSaveLoading: true,
        }
      case VERIFY_USER_EMAIL_DETAILS.VERIFY_USER_EMAIL_DETAILS_SUCCESS:
        return {
          ...state,
          errorMessage: '',
          onSaveLoading: false,
        }
      case VERIFY_USER_EMAIL_DETAILS.VERIFY_USER_EMAIL_DETAILS_ERORR:
        return {
          ...state,
          errorMessage: action.payload,
          onSaveLoading: false,
        }
      case GET_USERS_LIST.GET_USERS_LIST_INITLIZATION:
        return {
          ...state,
          ...action.payload,
          isLoading: true,
          progress: true,
          errorMessage: '',
          isLoggedout: false,
        }
      case GET_USERS_LIST.GET_USERS_LIST_SUCCESS:
        const userlistData: any = action.payload
        return {
          ...state,
          ...action.payload,
          errorMessage: '',
          isLoading: false,
          progress: true,
          userList: userlistData,
        }

      case GET_USERS_LIST.GET_USERS_LIST_ERORR:
        return {
          ...state,
          ...action.payload,
          errorMessage: action.payload,
          isLoading: false,
          progress: false,
        }

      case UPDATE_USER_DETAILS.UPDATE_USER_DETAILS_SUCCESS:
        return {
          ...state,
          userDetailsData: action.payload,
        }

      case FORGOT_PASSWORD.FORGOT_PASSWORD_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case FORGOT_PASSWORD.FORGOT_PASSWORD_SUCCESS:
        return {
          ...state,
          isLoading: false,
        }

      case FORGOT_PASSWORD.FORGOT_PASSWORD_ERORR:
        return {
          ...state,
          isLoading: false,
        }

      case RESET_PASSWORD.RESET_PASSWORD_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case RESET_PASSWORD.RESET_PASSWORD_SUCCESS:
        return {
          ...state,
          isLoading: false,
        }

      case RESET_PASSWORD.RESET_PASSWORD_ERORR:
        return {
          ...state,
          isLoading: false,
        }

      case FETCH_RANDOM_USERNAME_PWD.FETCH_RANDOM_USERNAME_PWD_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case FETCH_RANDOM_USERNAME_PWD.FETCH_RANDOM_USERNAME_PWD_SUCCESS:
        return {
          ...state,
          isLoading: false,
          randomUsernamePassword: action.payload,
        }

      case FETCH_RANDOM_USERNAME_PWD.FETCH_RANDOM_USERNAME_PWD_ERROR:
        return {
          ...state,
          isLoading: false,
        }

      case GET_QUALIFICATION.GET_QUALIFICATION_INITIALIZATION:
        return {
          ...state,
          isLoading: true,
        }
      case GET_QUALIFICATION.GET_QUALIFICATION_FAILED:
        return {
          ...state,
          isLoading: false,
        }

      case GET_QUALIFICATION.GET_QUALIFICATION_SUCCESS:
        const qualifications: any = action.payload
        return {
          ...state,
          isLoading: false,
          qualifications: qualifications?.data,
        }

      default:
        return state
    }
  }
)

export default reducer
